module.exports = __webpack_public_path__ + "img/villains.9f6f96eb.svg";